/**
 * Tabs Script
 */

import Glide from '@glidejs/glide'

var URLslideIndex = function ( index ) {
	// Get slide-index param from window if it exists
	const queryString = window.location.search;
	const urlParams = new URLSearchParams( queryString );
	const slideIndex = urlParams.get( 'step' );

	if ( null === slideIndex || '' === slideIndex || isNaN( slideIndex ) ) {
		return 0
	}

	return slideIndex
};

var simulateClick = function (elem) {
	// Create our event (with options)
	var evt = new MouseEvent('click', {
		bubbles: true,
		cancelable: true,
		view: window
	});
	// If cancelled, don't dispatch our event
	var canceled = !elem.dispatchEvent(evt);
};

document.addEventListener('DOMContentLoaded', function () {

	const createMobileTabs = (count) => {
		let list = document.createElement('div')
		list.classList.add('tab-buttons-mobile')
		list.setAttribute('data-glide-el', 'controls[nav]')
		for (let index = 0; index < count; index++) {
			let item = document.createElement('button')
			item.classList.add('tab-mobile-button')
			item.innerText = index + 1
			item.setAttribute('data-glide-dir', '=' + index )
			list.append(item)

			if ( index === (count - 1) ) {
				document.querySelector('.gtabs').prepend(list)
			}
		}
	}

	if ( 0 < document.querySelectorAll('.gtabs').length ) {
	
		// Resize height
		function glideHandleHeight() {
			const activeSlide = document.querySelector('.glide__slide--active');
			const activeSlideHeight = activeSlide ? activeSlide.offsetHeight : 0;
	
			const glideTrack = document.querySelector('.glide__track');
			const glideTrackHeight = glideTrack ? glideTrack.offsetHeight : 0;
	
			if (activeSlideHeight !== glideTrackHeight) {
				glideTrack.style.height = `${activeSlideHeight}px`;
			}
		}

		document.querySelector('.tab-button').classList.add('active')

		let tabsWrapper = document.querySelector('.glide')

		let glideTrack = document.querySelector('.glide__track')

		let nextButtons = document.querySelectorAll('.button-next')

		glideTrack.setAttribute('data-glide-el', 'track');

		let tabButtons = document.querySelectorAll('.tab-button')
	
		// Create mobile tab navigation
		createMobileTabs(tabButtons.length)
	
		setTimeout(() => {

			var tabs = new Glide('.gtabs', {
				type: 'slider',
				startAt: 0,
				perView: 1,
				swipeThreshold: false,
				dragThreshold: false,
				animationDuration: 0,
				rewindDuration: 0
			})

			tabs.on('mount.after', function() {

				// Desktop mobile classes
				tabButtons.forEach( (tabButton, index) => {
					tabButton.addEventListener('click', () => {

						document.querySelector('.tab-button.active').classList.remove('active')
						tabButton.classList.add('active')

						var prevButtons = document.querySelectorAll('.tab-button:nth-child(-n + ' + index + ')')
						for (var prevButton of prevButtons) {
							prevButton.classList.add('prev')
						}
						var nxtButtons = document.querySelectorAll('.tab-button:nth-child(n + ' + (index + 1) + ')')
						for (var nxtButton of nxtButtons) {
							nxtButton.classList.remove('prev')
						}

						tabs.go('=' + index)

						tabsWrapper.scrollIntoView({
							behavior: 'smooth',
							block: 'start',
							inline: 'center'
						})
					})
				});

				nextButtons.forEach((nextButton, index) => {
					nextButton.addEventListener('click', () => {
						simulateClick(tabButtons[index + 1])
					})
				});

				setTimeout(() => {
					if ( URLslideIndex() ) {
						var targetTab = URLslideIndex() - 1;
						simulateClick( document.querySelectorAll('.tab-button')[targetTab] )
					}
				}, 100);


			})

			// Automated height on Carousel build
			tabs.on('build.after', function (e) {

				glideHandleHeight();

			});
		
			// Automated height on Carousel change
			tabs.on('run.after', function () {
				glideHandleHeight();
			});

			tabs.on('run', function() {
				
				simulateClick( document.querySelectorAll('.tab-button')[tabs.index] )

				var prevButtons = document.querySelectorAll('.tab-mobile-button:nth-child(-n + ' + tabs.index + ')')
				for (var prevButton of prevButtons) {
					prevButton.classList.add('prev')
				}
				var nxtButtons = document.querySelectorAll('.tab-mobile-button:nth-child(n + ' + (tabs.index + 1) + ')')
				for (var nxtButton of nxtButtons) {
					nxtButton.classList.remove('prev')
				}

			})

			tabs.mount()

		}, 100 );
	}
	
}, false);